import { VirtualItem, Virtualizer } from "@tanstack/react-virtual";
import { ReactNode } from "react";
import { Table } from "semantic-ui-react";

export interface VirtualizedRowProps {
	columnVirtualizer: Virtualizer<HTMLDivElement, HTMLTableCellElement>;
	virtualPaddingLeft: number | undefined;
	virtualPaddingRight: number | undefined;
	children: (virtualItems: VirtualItem[]) => ReactNode;
}

export default function VirtualizedRow({
	columnVirtualizer,
	virtualPaddingLeft,
	virtualPaddingRight,
	children,
}: VirtualizedRowProps) {
	const virtualColumns = columnVirtualizer.getVirtualItems();

	return (
		<Table.Row style={{ display: "flex", width: "100%" }}>
			{typeof virtualPaddingLeft === "number" && virtualPaddingLeft > 0 ? (
				//fake empty column to the left for virtualization scroll padding
				<th style={{ display: "flex", width: virtualPaddingLeft }} />
			) : null}
			{children(virtualColumns)}
			{typeof virtualPaddingRight === "number" && virtualPaddingRight > 0 ? (
				//fake empty column to the right for virtualization scroll padding
				<th style={{ display: "flex", width: virtualPaddingRight }} />
			) : null}
		</Table.Row>
	);
}
